import Http from '../utils/http'
import store from 'store/index'

export const getAllPaged = (page = 1, extraParams = {}) => Http.get('/quotations', { params: { page, ...extraParams } })

export const getAll = (params = {}) => Http.get('/quotations', { params })

export const create = (deal, payload) => {
    return Http.post(`/deals/${deal}/quotations`, payload)
       .then(response => {
           store.dispatch('saveQuotation', response.data)
           return response.data
       })
}

export const update = (deal, id, payload) => {
    return Http.put(`/deals/${deal}/quotations/${id}`, payload)
       .then(response => {
           store.dispatch('saveQuotation', response.data)
           return response.data
       })
}

export const destroy = (deal, id) => {
    return Http.delete(`/deals/${deal}/quotations/${id}`)
       .then(response => {
           store.dispatch('destroyQuotation', id)
           return response.data
       })
}

export const send = (deal, id, payload) => {
    return Http.put(`/deals/${deal}/quotations/${id}/send-email`, payload)
       .then(response => {
           store.dispatch('saveQuotation', response.data.quotation)
           store.dispatch('saveEmail', response.data.email)
           return response.data
       })
}

export const clone = (deal, id) => {
    return Http.put(`/deals/${deal}/quotations/${id}/clone`)
       .then(response => {
           store.dispatch('saveQuotation', response.data)
           return response.data
       })
}

export const changeStatus = (deal, id, status) => {
    return Http.put(`/deals/${deal}/quotations/${id}/${status}`)
        .then(response => {
            store.dispatch('saveQuotation', response.data)
            return response.data
        })
}



// WEBPACK FOOTER //
// ./src/services/quotations.js